<template>
    <div v-if="offer" class="mb-5">
        <strong v-for="(itinerary, index) in offer.itinerary" :key="index" class="d-block">
            {{ itinerary.segments[0].departure.airportCode }},
            {{ $filters.dateTimeFormat(itinerary.segments[0].departure.date) }} -
            {{ itinerary.segments[itinerary.segments.length - 1].arrival.airportCode }},
            {{ $filters.dateTimeFormat(itinerary.segments[itinerary.segments.length - 1].arrival.date) }}
        </strong>
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {EventBus, SHOW_FLIGHT_CONDITIONS_INFO} from '@/utils/event-bus'

    @Component
    export class FlightConditionsModalInfo extends Vue {
        offer = null

        mounted() {
            EventBus.$on(SHOW_FLIGHT_CONDITIONS_INFO, this.showInfo)
        }

        beforeUnmount() {
            EventBus.$off(SHOW_FLIGHT_CONDITIONS_INFO, this.showInfo)
        }

        showInfo(offer) {
            this.offer = offer
        }
    }

    export default FlightConditionsModalInfo
</script>
